import React from 'react';
import './Schalldaempfer.css';
import { FormattedMessage } from "react-intl";

import BestellschluesselSchalldaempfer from "../bestellschluessel/BestellschluesselSchalldaempfer";
import Kulissenspaltbreite from "../eingabe/Kulissenspaltbreite";
import Gewichtsberechnung from "../gewichtsberechnung/Gewichtsberechnung";
import Einfuegungsdaempfung from "../einfuegungsdaempfung/Einfuegungsdaempfung";
import Anstroemgeschwindigkeit from "../anstroemgeschwindigkeit/Anstroemgeschwindigkeit";
import Preisberechnung from "../preisberechnung/Preisberechnung";
import Spaltgeschwindigkeit from "../effektive-spaltegeschwindigkeit/Spaltgeschwindigkeit";
import Schallleistungspegel from "../schallleistungspegel/Schallleistungspegel";
import Druckverlust from "../druckverlust/Druckverlust";
import LwA from "../schallleistungspegel/LwA";
import { getPdfDownloadFileName } from "../utils/windowsFileName";
import { calculateDruckverlust } from "../calculations/pressureLoss";
import { PRESSURE_DROP_WARNING_THRESHOLD } from "../constants/pressureDrop";


class Schalldaempfer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kulissenspaltbreite: 100,
      anstroemgeschwindigkeit: 0,
      spaltgeschwindigkeit: 0,
        hz32: 0,
        hz63: 0,
        hz125: 0,
        hz250: 0,
        hz500: 0,
        hz1000: 0,
        hz2000: 0,
        hz4000: 0,
        hz8000: 0,
      preis:0,
      isPdfDownloadPreparing: false,

    };
    this.handleKulissenspaltbreiteChange = this.handleKulissenspaltbreiteChange.bind(this);
    this.handleAnstroemgeschwindigkeitChange = this.handleAnstroemgeschwindigkeitChange.bind(this);
    this.handleSpaltgeschwindigkeitChange = this.handleSpaltgeschwindigkeitChange.bind(this);
    this.handleDaempfungsChange = this.handleDaempfungsChange.bind(this);
    this.handlePreisChange = this.handlePreisChange.bind(this);
    this.handlePdfDownload = this.handlePdfDownload.bind(this);
  }
  //Bestehend aus Gewichtsberechnung,
  //Interpolierte Dämpfung
  //Interpoliertes Eigenrauschen
  //Anzahl Kulissen
  //Preis
  //


  handleKulissenspaltbreiteChange(value){
      if(value !== this.state.kulissenspaltbreite) {
          this.setState({kulissenspaltbreite: value});
      }
  }
  handleAnstroemgeschwindigkeitChange(value){
        if(value !== this.state.anstroemgeschwindigkeit) {
          this.setState({anstroemgeschwindigkeit: value});
      }
  }

  handleSpaltgeschwindigkeitChange(value){
        if(value !== this.state.spaltgeschwindigkeit) {
          this.setState({spaltgeschwindigkeit: value});
      }
  }

  handleDaempfungsChange(target, value) {
    //const target = event.target;
    //const value = target.name === 'isGoing' ? target.checked : target.value;

    const name =  "hz" + target;
    if(this.state[name] !== value){
         this.setState({
      [name]: value    });
    }
    // console.log("DnameChange:"+ name);
    // console.log(value);

    // console.log('Name:' + this.state.name);
    // console.log('Target-Name:' + target.name);
    // console.log('Target-value:' + target.value);
  }

  handlePreisChange(value){
    if(value !== this.state.preis) {
        this.setState({preis: value});
    }
  }


  getPdfDocumentProps() {
    const bestelnr = <BestellschluesselSchalldaempfer id={"Bestellschluessel"} Kulissentyp={this.props.Kulissentyp} Kulissenbreite={this.props.Kulissenbreite} Kulissenanzahl={this.props.AnzahlKulissen}  SelectedAnschlussprofil={this.props.SelectedAnschlussprofil} Schalldaempferbreite={this.props.Schalldaempferbreite} Schalldaempferhoehe={this.props.Schalldaempferhoehe} Schalldaempferlaenge={this.props.Schalldaempferlaenge} Kulissenspaltbreite={this.state.kulissenspaltbreite} />;
    const druckverlust = <Druckverlust
      Anstroemgeschwindigkeit={this.state.anstroemgeschwindigkeit}
      Kulissenhoehe={this.props.Schalldaempferhoehe}
      Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}
      Kulissenspaltbreite={this.state.kulissenspaltbreite}
      Kulissenbreite={this.props.Kulissenbreite}
      Kulissenlaenge={this.props.Schalldaempferlaenge}
      AnzahlKulissen={this.props.AnzahlKulissen}
    />;
    const schallpegelleistung = <Schallleistungspegel
      Kulissenspalt={this.state.kulissenspaltbreite}
      Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}
      Kulissenlaenge={this.props.Schalldaempferlaenge}
      Kulissentyp={this.props.Kulissentyp}
      Kulissenbreite={this.props.Kulissenbreite}
    />;
    const gewicht = <Gewichtsberechnung Schalldaempferbreite={this.props.Schalldaempferbreite}
      Schalldaempferlaenge={this.props.Schalldaempferlaenge}
      Schalldaempferhoehe={this.props.Schalldaempferhoehe}
      Kulissenbreite={this.props.Kulissenbreite}
      Kulissenhoehe={this.props.Schalldaempferhoehe}
      Kulissenlaenge={this.props.Schalldaempferlaenge}
      Kulissenanzahl={this.props.AnzahlKulissen}
      Kulissentyp={this.props.Kulissentyp}
      Druckbereich={this.props.Druckbereich}
      SelectedAnschlussprofil={this.props.SelectedAnschlussprofil}
      CalculatedAnschlussprofil={this.props.CalculatedAnschlussprofil}
      CheckedAnschlussprofil={this.props.CheckedAnschlussprofil}/>;
    const lwa = <LwA
      Anstroemgeschwindigkeit={this.state.anstroemgeschwindigkeit}
      Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}
      Schalldaempferhoehe={this.props.Schalldaempferhoehe}
      Schalldaempferbreite={this.props.Schalldaempferbreite}
      AnzahlKulissen={this.props.AnzahlKulissen}
      Kulissenbreite={this.props.Kulissenbreite}
    />;

    return {
      Bestellnummer: bestelnr,
      Kulissentyp: this.props.Kulissentyp,
      Kulissenbreite: this.props.Kulissenbreite,
      Spaltbreite: this.state.kulissenspaltbreite,
      Kulissenanzahl: this.props.AnzahlKulissen,
      Schalldaempferbreite: this.props.Schalldaempferbreite,
      Schalldaempferhoehe: this.props.Schalldaempferhoehe,
      Schalldaempferlaenge: this.props.Schalldaempferlaenge,
      Volumenstrom: this.props.Volumenstrom,
      Anstroemgeschwindigkeit: this.state.anstroemgeschwindigkeit.toFixed(2),
      Spaltgeschwindigkeit: this.state.spaltgeschwindigkeit.toFixed(2),
      Schallpegelleistung: schallpegelleistung,
      Druckverlust: druckverlust,
      Gewicht: gewicht,
      hz32: this.state.hz32.toFixed(0),
      hz63: this.state.hz63.toFixed(0),
      hz125: this.state.hz125.toFixed(0),
      hz250: this.state.hz250.toFixed(0),
      hz500: this.state.hz500.toFixed(0),
      hz1000: this.state.hz1000.toFixed(0),
      hz2000: this.state.hz2000.toFixed(0),
      hz4000: this.state.hz4000.toFixed(0),
      hz8000: this.state.hz8000.toFixed(0),
      Preis: this.state.preis,
      Optionen: this.props.Optionen,
      Rabatt: this.props.Rabatt,
      LwA: lwa,
      PdfFileName: this.props.PdfFileName,
      currentLocale: this.props.currentLocale,
    };
  }

  async handlePdfDownload() {
    if (!this.props.IsPdfFileNameValid || this.state.isPdfDownloadPreparing) {
      return;
    }

    this.setState({isPdfDownloadPreparing: true});

    if (typeof window !== "undefined" && !window.process) {
      window.process = {env: {NODE_ENV: "production"}};
    }

    try {
      const [pdfRenderer, datenblattModule] = await Promise.all([
        import("@react-pdf/renderer"),
        import("../pdf/Datenblatt"),
      ]);
      const pdf = pdfRenderer.pdf || (pdfRenderer.default && pdfRenderer.default.pdf);
      const Datenblatt = datenblattModule.default;
      const blob = await pdf(<Datenblatt {...this.getPdfDocumentProps()} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = getPdfDownloadFileName(this.props.PdfFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } finally {
      this.setState({isPdfDownloadPreparing: false});
    }
  }
    ausgabepreis(ausgabepreis){

          if ( ausgabepreis > 0){
              return ausgabepreis + ' €';
          }
          else {
              return <FormattedMessage id='Preis_auf_Anfrage' />;
          }
    }

    // Berechnet den Druckverlust nur für die Warn-Hervorhebung (Issue #23):
    // Übersteigt er den Grenzwert, wird die Wertzeile rot hinterlegt – analog
    // zu Anström-/Spaltgeschwindigkeit. Es werden dieselben Eingaben wie für
    // die <Druckverlust />-Anzeige verwendet; die bestehende Berechnungs-
    // funktion bleibt unverändert (keine Änderung der Berechnungslogik).
    druckverlustWert(){
        return calculateDruckverlust({
            Anstroemgeschwindigkeit: this.state.anstroemgeschwindigkeit,
            Kulissenspaltbreite: this.state.kulissenspaltbreite,
            Kulissenbreite: this.props.Kulissenbreite,
            Kulissenhoehe: this.props.Schalldaempferhoehe,
            Kulissenlaenge: this.props.Schalldaempferlaenge,
            AnzahlKulissen: this.props.AnzahlKulissen,
        });
    }

    // Auf ganze Pa gerundeter Druckverlust – genau der Wert, den
    // <Druckverlust /> anzeigt (toFixed(0)). Maßgeblich für die rote
    // Hervorhebung, damit Hintergrund und angezeigter Wert konsistent sind
    // (z. B. zeigt 90,4 Pa "90 Pa" und bleibt normal dargestellt).
    angezeigterDruckverlust(){
        return Number(this.druckverlustWert().toFixed(0));
    }


  render() {
        const isPdfFileNameValid = this.props.IsPdfFileNameValid;

    return (
     <>
      <div className={"form-style-8"}>
        <h2><FormattedMessage id='Schalldaempfer' /></h2>
        <h3><label htmlFor={"Bestellschluessel"}><FormattedMessage id='Bestellschluessel' />: </label></h3>
        <p>
          <BestellschluesselSchalldaempfer id={"Bestellschluessel"} Kulissentyp={this.props.Kulissentyp} Kulissenbreite={this.props.Kulissenbreite} Kulissenanzahl={this.props.AnzahlKulissen}  SelectedAnschlussprofil={this.props.SelectedAnschlussprofil} Schalldaempferbreite={this.props.Schalldaempferbreite} Schalldaempferhoehe={this.props.Schalldaempferhoehe} Schalldaempferlaenge={this.props.Schalldaempferlaenge} Kulissenspaltbreite={this.state.kulissenspaltbreite} />
        </p>
        <h3><label><FormattedMessage id='Gewicht' />: </label></h3>
        <p>
            <Gewichtsberechnung Schalldaempferbreite={this.props.Schalldaempferbreite}
                                 Schalldaempferlaenge={this.props.Schalldaempferlaenge}
                                 Schalldaempferhoehe={this.props.Schalldaempferhoehe}
                                 Kulissenbreite={this.props.Kulissenbreite}
                                 Kulissenhoehe={this.props.Schalldaempferhoehe}
                                 Kulissenlaenge={this.props.Schalldaempferlaenge}
                                 Kulissenanzahl={this.props.AnzahlKulissen}
                                 Kulissentyp={this.props.Kulissentyp}
                                 Druckbereich={this.props.Druckbereich}
                                 SelectedAnschlussprofil={this.props.SelectedAnschlussprofil}
                                 CalculatedAnschlussprofil={this.props.CalculatedAnschlussprofil}
                                 CheckedAnschlussprofil={this.props.CheckedAnschlussprofil}/><span> kg</span>
        </p>
        <h3><label><FormattedMessage id='Kulissenspalt' />: </label></h3>
          <p><Kulissenspaltbreite Kanalbreite={this.props.Schalldaempferbreite} AnzahlKulissen={this.props.AnzahlKulissen} Kulissenbreite={this.props.Kulissenbreite} KulissenspaltbreiteChange={this.handleKulissenspaltbreiteChange} /><span> mm</span></p>

          <h3><label><FormattedMessage id='Anstroemgeschwindigkeit' />: </label></h3>
          <p className={this.state.anstroemgeschwindigkeit > 25 ? "filter"  : "nofilter"} >
                  <Anstroemgeschwindigkeit Volumenstrom={this.props.Volumenstrom}
                                        Schalldaempferbreite={this.props.Schalldaempferbreite}
                                        Schalldaempferhoehe={this.props.Schalldaempferhoehe}
                                        AnstroemgeschwindigkeitChange={this.handleAnstroemgeschwindigkeitChange}
                  /><span> m/s</span>

          </p>

          <h3><label><FormattedMessage id='Spaltgeschwindigkeit' />: </label></h3>
          <p className={this.state.spaltgeschwindigkeit > 25 ? "filter"  : "nofilter" }>
              <Spaltgeschwindigkeit Volumenstrom={this.props.Volumenstrom}
                                        Kulissenspaltbreite={this.state.kulissenspaltbreite}
                                        Kulissenhoehe={this.props.Schalldaempferhoehe}
                                        AnzahlKulissen={this.props.AnzahlKulissen}
                                        SpaltgeschwindigkeitChange={this.handleSpaltgeschwindigkeitChange}
              />
          </p>
          <h3><label><FormattedMessage id='Druckverlust' />: </label></h3>
          <p className={this.angezeigterDruckverlust() > PRESSURE_DROP_WARNING_THRESHOLD ? "filter" : "nofilter"}>
              <Druckverlust
                               Anstroemgeschwindigkeit = {this.state.anstroemgeschwindigkeit}
                               Kulissenhoehe = {this.props.Schalldaempferhoehe}
                               Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}
                               Kulissenspaltbreite = {this.state.kulissenspaltbreite}
                               Kulissenbreite = {this.props.Kulissenbreite}
                               Kulissenlaenge={this.props.Schalldaempferlaenge}
                               AnzahlKulissen={this.props.AnzahlKulissen}
               /><span> Pa</span>
          </p>

          <h3><label><FormattedMessage id='LwA' />:</label></h3>
          <p>
              <LwA
                  Anstroemgeschwindigkeit = {this.state.anstroemgeschwindigkeit}
                  Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}
                  Schalldaempferhoehe = {this.props.Schalldaempferhoehe}
                  Schalldaempferbreite = {this.props.Schalldaempferbreite}
                  AnzahlKulissen={this.props.AnzahlKulissen}
                  Kulissenbreite = {this.props.Kulissenbreite}

              /><span> dB(A)</span>
          </p>

          <h3><label>{this.props.Rabatt > 0 ? <FormattedMessage id="Preis_mit_Rabatt" values={{ n: this.props.Rabatt }} /> : <FormattedMessage id='Preis'/> }</label></h3>
          <p><strong>
              <Preisberechnung Schalldaempferbreite={this.props.Schalldaempferbreite}
                               Schalldaempferlaenge={this.props.Schalldaempferlaenge}
                               Schalldaempferhoehe={this.props.Schalldaempferhoehe}
                               AnzahlKulissen={this.props.AnzahlKulissen}
                               Druckbereich={this.props.Druckbereich}
                               Kulissenbreite={this.props.Kulissenbreite}
                               Kulissentyp={this.props.Kulissentyp}
                               Rabatt={this.props.Rabatt}
                               Optionen={this.props.Optionen}
                               PreisChange={this.handlePreisChange}
              />
            {this.ausgabepreis(this.state.preis.toFixed(2))}</strong>
          </p>

        <h3><label><FormattedMessage id='Einfuegungsdaempfung' /></label></h3>
          {/*{this.state.hz63}*/}
          {/*{this.state.hz125}*/}
          {/*{this.state.hz250}*/}
          {/*{this.state.hz500}*/}
          {/*{this.state.hz1000}*/}
          {/*{this.state.hz2000}*/}
          {/*{this.state.hz4000}*/}
          {/*{this.state.hz8000}*/}

          {Number(this.state.hz63) === 0 &&
           Number(this.state.hz125) === 0 &&
           Number(this.state.hz250) === 0 &&
           Number(this.state.hz500) === 0 &&
           Number(this.state.hz1000) === 0 &&
           Number(this.state.hz2000) === 0 &&
           Number(this.state.hz4000) === 0 &&
          Number(this.state.hz8000) === 0 ? <h3><FormattedMessage id='Daempfungswerte_auf_Anfrage' /></h3> : ""}

          <div className={"resTable"}>

              <table>
                  <tbody>


                  <tr>
                        {/*<th>Bestellschlüssel</th>*/}
                        {/*<th>32 hz</th>*/}
                        <th>63 hz</th>
                        <th>125 hz</th>
                        <th>250 hz</th>
                        <th>500 hz</th>
                        <th>1000 hz</th>
                        <th>2000 hz</th>
                        <th>4000 hz</th>
                        <th>8000 hz</th>
                        {/*<th>Gewicht in kg</th>*/}
                        {/*<th>Kulissenspalt [mm]</th>*/}
                        {/*<th>Anstörmgeschwingkeit [m/s]</th>*/}
                        {/*<th>Luftgeschwindigkeit im Kulissenspalt [m/s]</th>*/}
                        {/*<th>Preis €</th>*/}
                        {/*<th>LWA</th>*/}
                        {/*<th>Pa</th>*/}
                  </tr>
                  <tr>
                {/*<td><BestellschluesselSchalldaempfer Kulissentyp={this.props.Kulissentyp} Kulissenbreite={this.props.Kulissenbreite} Kulissenanzahl={this.props.AnzahlKulissen}  SelectedAnschlussprofil={this.props.SelectedAnschlussprofil} Schalldaempferbreite={this.props.Schalldaempferbreite} Schalldaempferhoehe={this.props.Schalldaempferhoehe} Schalldaempferlaenge={this.props.Schalldaempferlaenge} Kulissenspaltbreite={this.state.kulissenspaltbreite} /></td>*/}
                    <Einfuegungsdaempfung Kulissenspalt={this.state.kulissenspaltbreite}
                                   Kulissenlaenge={this.props.Schalldaempferlaenge}
                                   Einfuegedaempfungsdaten={this.props.Einfuegedaempfungsdaten}
                                   Kulissentyp={this.props.Kulissentyp}
                                   Kulissenbreite={this.props.Kulissenbreite}
                                   Filter32hz={this.props.Filter32hz}
                                   Filter63hz={this.props.Filter63hz}
                                   Filter125hz={this.props.Filter125hz}
                                   Filter250hz={this.props.Filter250hz}
                                   Filter500hz={this.props.Filter500hz}
                                   Filter1000hz={this.props.Filter1000hz}
                                   Filter2000hz={this.props.Filter2000hz}
                                   Filter4000hz={this.props.Filter4000hz}
                                   Filter8000hz={this.props.Filter8000hz}
                                   DaempfungsChange={this.handleDaempfungsChange}
                    />

                {/*<td>{this.state.kulissenspaltbreite}</td>*/}



           {/*<td>*/}
           {/*    <Schallleistungspegel*/}
           {/*                    Kulissenspalt={this.state.kulissenspaltbreite}*/}
           {/*                    Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}*/}
           {/*                    Kulissenlaenge={this.props.Schalldaempferlaenge}*/}
           {/*                    Kulissentyp={this.props.Kulissentyp}*/}
           {/*                    Kulissenbreite={this.props.Kulissenbreite} /><span> dB</span>*/}
           {/*</td>*/}
           {/*<td>*/}
           {/*    <Druckverlust*/}
           {/*                    Anstroemgeschwindigkeit = {this.state.anstroemgeschwindigkeit}*/}
           {/*                    Kulissenhoehe = {this.props.Schalldaempferhoehe}*/}
           {/*                    Kulissenspaltgeschwindigkeit={this.state.spaltgeschwindigkeit}*/}
           {/*                    Kulissenspaltbreite = {this.state.kulissenspaltbreite}*/}
           {/*                    Kulissenbreite = {this.props.Kulissenbreite}*/}
           {/*                    Kulissenlaenge={this.props.Schalldaempferlaenge}*/}
           {/*                    AnzahlKulissen={this.props.AnzahlKulissen}*/}
           {/*    />*/}
           {/*</td>*/}

            </tr>
          </tbody>
         {/*<div>{console.log("Kulissenspaltbreite: " +this.getKulissenspaltbreite())}</div>*/}
        </table>


         </div>


                <button
                    type="button"
                    className={"download"}
                    disabled={!isPdfFileNameValid || this.state.isPdfDownloadPreparing}
                    onClick={this.handlePdfDownload}
                >
                    {isPdfFileNameValid ? <FormattedMessage id='Datenblatt' /> : <FormattedMessage id='Fehlerhafter_Dateiname' />}
                </button>












     </div>

     </>
    );
  }
}
export default Schalldaempfer;
